import { getRequest, postRequest } from "NetworkCall";
import { INSTANCE_URL } from "Constants";

import { SPEAKER_TOTAL_NOOFSPKR } from "SpeakeranalyticNoofspkrAction";
import { SPEAKER_TOTAL_SPKRLISTVIEW } from "SpeakeranalyticSpkrlistviewAction";
import { SPEAKER_TOTAL_SPKRPROFVIEW } from "SpeakeranalyticSpkrprofviewAction";
import { SPEAKER_TOTAL_SPKRFAVO } from "SpeakeranalyticSpkrfavoAction";

export var SPEAKER_NOOFSPKR = "SPEAKER_NOOFSPKR";
export var SPEAKER_SPKRLISTVIEW = "SPEAKER_SPKRLISTVIEW";
export var SPEAKER_SPKRPROFVIEW = "SPEAKER_SPKRPROFVIEW";
export var SPEAKER_SPKRSEARCH = "SPEAKER_SPKRSEARCH";
export var SPEAKER_SPKRFAVO = "SPEAKER_SPKRFAVO";
export var SPEAKER_TOPSPKR_TABLELIST = "SPEAKER_TOPSPKR_TABLELIST";
export var SPEAKER_MOSTSEARKEYS_TABLELIST = "SPEAKER_MOSTSEARKEYS_TABLELIST";
// Charts
export const SPEAKER_ENGAGEMENT_BARCHART = "SPEAKER_ENGAGEMENT_BARCHART";
export var SPEAKER_SELECTED_ITEM = "SPEAKER_SELECTED_ITEM";
export var SPEAKER_ITEM_SELECTED = "SPEAKER_ITEM_SELECTED"; // main

// Tab on select
export function onSpeakerMenuSelected(selectedMenu) {
  return (dispatch) => {
    dispatch({ type: SPEAKER_ITEM_SELECTED, payload: selectedMenu });
  };
}

export function dispatchAnalyticsData(data) {
  return (dispatch) => {
    //dispatch({type: SPEAKER_TOTAL_POST, payload: {count:data}}); count:data.devices.count
    dispatch({ type: SPEAKER_TOTAL_NOOFSPKR, payload: { count: data } });
    dispatch({ type: SPEAKER_TOTAL_SPKRLISTVIEW, payload: { count: data } });
    dispatch({ type: SPEAKER_TOTAL_SPKRPROFVIEW, payload: { count: data } });
    dispatch({ type: SPEAKER_TOTAL_SPKRFAVO, payload: { count: data } });
  };
}

// Top speakers (speaker profiles with most user engagement)
const fetchTopSpeakerTableData = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=topScreensTable`;
  return (dispatch) => {
    postRequest(
      url,
      {
        type: "topScreensTable",
        types: "entry",
        bkmrktypes: "speaker",
        screen: "speakers",
        tablename: "speaker",
        eventid: session.eventid,
      },
      session,
      dispatch,
      (response) => {
        var data = response;

        //Prepare data for Top speakers Table data (List) Installs..
        dispatch({ type: SPEAKER_TOPSPKR_TABLELIST, data: data.resource });
        callback({
          error: 0,
          data: "Analytics Top speaker Table data Fetched !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

// MOst search keywords (most search keywords related to speakers)
const fetchMostsearkeysTableData = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=mostsearkeyslist`;
  return (dispatch) => {
    postRequest(
      url,
      {
        type: "mostsearkeyslist",
        types: "search",
        screen: "speakers",
        eventid: session.eventid,
      },
      session,
      dispatch,
      (response) => {
        var data = response;

        //Prepare data for Top speakers Table data (List) Installs..
        dispatch({ type: SPEAKER_MOSTSEARKEYS_TABLELIST, data: data.resource });
        callback({
          error: 0,
          data: "Analytics Most search speakers Table data Fetched !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

// Speakers Engagement (Chart view of how actively the speaker feature has been use over the selected date range)
const fetchspkrengagementbBarChart = (session, daterange, callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=typesFeatureEngmntData`;

  return (dispatch) => {
    postRequest(
      url,
      {
        type: "typesFeatureEngmntData",
        types: "type",
        screen: "speakers",
        bkmrktype: "speaker",
        eventid: session.eventid,
        fromDate: daterange.from,
        toDate: daterange.to,
      },
      session,
      dispatch,
      (response) => {
        var data = response;

        dispatch({
          type: SPEAKER_ENGAGEMENT_BARCHART,
          payload: { response: data.resource },
        });
        callback({ error: 0, data: "Analytics Speakers Engagement Fetched !" });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

export {
  fetchMostsearkeysTableData,
  fetchTopSpeakerTableData,
  fetchspkrengagementbBarChart,
};
